<template>
  <div class="commentPage">
    <NavBar />
    <div class="commentList">
      <van-empty v-if="!loading && list.length === 0" description="No reviews" />
      <div v-for="item in list" :key="item.comment_id" class="commentCard">
        <div class="cardTop">
          <van-rate
            :value="Number(item.score) || 0"
            readonly
            :size="16"
            color="#FFB400"
            void-color="#E5E5E5"
          />
          <div class="meta">{{ formatUserMeta(item) }}</div>
        </div>
        <div class="serviceName">{{ item.service_name || '' }}</div>
        <div class="staffName">{{ formatTechnician(item) }}</div>
        <div class="content">
          {{ item.content || '' }}
        </div>
      </div>
      <div v-if="loading" class="loading">Loading...</div>
    </div>
  </div>
</template>
<script>
import NavBar from '@/components/NavBar/index.vue'
export default {
  name: 'MyComment',
  components: { NavBar },
  data() {
    return {
      loading: false,
      list: [],
      userInfo: null
    }
  },
  mounted() {
    // 读取缓存用户信息（用于展示Nickname）
    try {
      const cached = localStorage.getItem('userInfo')
      this.userInfo = cached ? JSON.parse(cached) : null
    } catch (e) {
      this.userInfo = null
    }
    this.fetchList()
  },
  methods: {
    async fetchList() {
      this.loading = true
      try {
        const res = await this.$api.getMyCommentList({ app_id: 10001 })
        if (res && res.code === 1 && res.data) {
          this.list = Array.isArray(res.data.list) ? res.data.list : []
        } else {
          this.$toast && this.$toast.fail((res && res.msg) ? res.msg : 'Failed to load reviews')
        }
      } catch (e) {
        // request 拦截器可能已提示，这里不重复 toast
      } finally {
        this.loading = false
      }
    },
    formatUserMeta(item) {
      const name = (this.userInfo && this.userInfo.nickName) ? this.userInfo.nickName : 'User'
      const date = item && item.create_time ? item.create_time : ''
      return `${name} · ${date}`
    },
    formatTechnician(item) {
      const t = item && item.OrderService && item.OrderService.technician
      const n = t && t.name ? t.name : ''
      return n ? `Staff: ${n}` : ''
    }
  }
}
</script>
<style lang="scss" scoped>
.commentPage{
  width: 100%;
  min-height: 100%;
  background: #f7f7f7;
}
.commentList{
  padding: 0.75rem 1rem 1.25rem;
  box-sizing: border-box;
}
.commentCard{
  background: #fff;
  border-radius: 0.5rem;
  padding: 0.75rem;
  box-sizing: border-box;
  margin-bottom: 0.75rem;
}
.cardTop{
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
}
.meta{
  color: #999;
  font-size: 0.75rem;
  white-space: nowrap;
}
.serviceName{
  margin-top: 0.5rem;
  color: #333;
  font-size: 0.875rem;
  font-weight: 600;
}
.staffName{
  margin-top: 0.25rem;
  color: #666;
  font-size: 0.8125rem;
}
.content{
  margin-top: 0.5rem;
  background: #f2f2f2;
  border-radius: 0.5rem;
  padding: 0.75rem;
  color: #666;
  font-size: 0.875rem;
  line-height: 1.6;
  word-break: break-word;
}
.loading{
  padding: 0.75rem;
  color: #666;
  text-align: center;
}
</style>
